import { invalidateMinicart } from "~/app/store/bffApi";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { getCurrentBrowserTimezone } from "~/common/utils/dateUtils";
import { toMoxyDateNullable, type MoxyDateString } from "~/common/types/MoxyDate";
import { type LineItem } from "~/features/cart/cart/models/CartData";
import { getHybrisProductCode } from "~/utils/cartHelper";

interface UpdateQuoteApiItem {
  productCode: string;
  packageSize?: number;
  packageCode: string;
  quantity: number;
  comment?: string;
  internalComment?: string;
  selectedDeliveryDate?: MoxyDateString | null;
  primaryWarehouseCode: string;
  offerPrice?: number;
  targetPrice?: number;
  minimumSellingPrice?: number;
  recommendedSellingPrice?: number;
  priceReference?: string;
  orderEntryNumber: number;
  packageEntryNumber: number;
  packageEntryPk: number;
  orderEntryPk: number;
}

interface UpdateQuoteItem {
  productCode: string;
  packageSize?: number;
  packageCode: string;
  quantity: number;
  comment?: string;
  internalComment?: string;
  selectedDeliveryDate: Date | null;
  primaryWarehouseCode: string;
  offerPrice?: number;
  targetPrice?: number;
  /**
   * Needs to be per piece or BE freaks out
   * TODO: Update BE to accept per {unitPrice} pieces
   */
  msp?: number;
  /**
   * Needs to be per piece or BE freaks out
   * TODO: Update BE to accept per {unitPrice} pieces
   */
  rsp?: number;
  priceReference: string;
  orderEntryNumber: number;
  packageEntryNumber: number;
  packageEntryPk: number;
  orderEntryPk: number;
}

function transform(item: UpdateQuoteItem): UpdateQuoteApiItem {
  const rdd = item.selectedDeliveryDate;
  const { msp, rsp, ...baseItem } = item;

  return {
    ...baseItem,
    selectedDeliveryDate: toMoxyDateNullable(rdd),
    // TEMP CHANGE - add new line character to internal comment
    internalComment: item.internalComment ? item.internalComment + "\n" : "",
    minimumSellingPrice: msp,
    recommendedSellingPrice: rsp,
  };
}

export function fromLineItem(data: LineItem): UpdateQuoteItem {
  return {
    productCode: getHybrisProductCode(data.productCode),
    packageSize: data.packSize,
    packageCode: data.packCode,
    quantity: data.quantity,
    comment: data.comment,
    selectedDeliveryDate: data.deliveryDate,
    // estimatedDeliveryDate: (data.edd && data.edd.type === 'estimate') ? data.edd.date : undefined,
    primaryWarehouseCode: data.primaryWarehouseCode,
    priceReference: data.priceReference,

    msp: data.msp ? data.msp.value : undefined,
    rsp: data.rsp ? data.rsp.value : undefined,
    internalComment: data.internalComment,
    offerPrice: data.offerPrice ? data.offerPrice.value : undefined,
    targetPrice: data.targetPrice ? data.targetPrice.value : undefined,

    orderEntryNumber: data.entryNumber!,
    packageEntryNumber: data.entryNumber!,
    orderEntryPk: data.cartEntryPk,
    packageEntryPk: data.pk,
  };
}

const bulkUpdateApiUrl = occUrl("/quote/update/bulk");

export function sendBulkUpdate(items: UpdateQuoteItem[]) {
  const body = {
    items: items.map(transform),
    userTimeZone: getCurrentBrowserTimezone(),
  };

  return performUpdate(bulkUpdateApiUrl, JSON.stringify(body));
}

const updateApiUrl = occUrl("/quote/update");

export function sendUpdate(data: UpdateQuoteItem) {
  const body = transform(data);

  return performUpdate(updateApiUrl, JSON.stringify(body));
}

function performUpdate(url: string, body: string) {
  return occFetch(url, {
    body: body,
    cache: "no-cache",
    method: "POST",
    headers: {
      dataType: "json",
      "content-type": "application/json",
    },
    redirect: "follow",
  }).then((result) => {
    invalidateMinicart();
    return result;
  });
}
